import type { I18NMessages } from '@atlaskit/intl-messages-provider/types';

import defaultMessages from '../../../i18n/en';
import { asyncLanguages } from './async-languages';

export const fetchMessages = async (locale: string): Promise<I18NMessages | undefined> => {
	try {
		// Fallback to the generic locale if specified one is not found
		const languageLocale =
			locale in asyncLanguages
				? locale
				: locale.replace(/-/g, '_') in asyncLanguages
					? locale.replace(/-/g, '_')
					: locale.split(/[-_]/)[0] || '';

		// Dynamic import of the locale file
		const localeMessages = (await asyncLanguages[languageLocale]?.()) as
			| { default: I18NMessages }
			| undefined;

		return localeMessages?.default ?? defaultMessages;
	} catch (e) {
		// ignore
	}

	return defaultMessages;
};
